<div #renderer class="content-border">
  <div class="row">
    <div class="col-12">
      <div class="zoom-slider">
        <hld-zoom-slider
          [zoomLevel]="zoomLevel"
          [maxZoom]="maxZoom"
          [minZoom]="minZoom"
          [zoomStep]="zoomStep"
          (zoomChange)="onZoomChange($event)"
        ></hld-zoom-slider>
      </div>
    </div>
  </div>
</div>
